import logo from './logo.svg';
import './App.css';
import { Button, Container, Nav, Navbar, Carousel, Card } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Fade } from 'react-reveal'
import Flash from 'react-reveal/Flash';
import Bea from "./images/good-bea.gif"
import Wave from './images/wave.svg'
import Wolfez from './images/wolfez.gif'
import McDonalds from './images/mcsmith.jpg'
import infer from './images/infer.png'

const socials = [
  <><a href="https://twitter.com/@_beanep" target="_blank"><i class="bi bi-twitter"></i> Twitter: @_beanep</a></>,
  <><i class="bi bi-discord"></i> Discord: bea#9240</>
]
function App() {
  return (
    <>
      <Navbar className="bg-light fixed-top" variant="primary">
        <Container>
          <Navbar.Brand href="#home">
            <h2>Beanep</h2>
          </Navbar.Brand>
          <Nav>
            <Nav.Link href="#home">Home</Nav.Link>
            <Nav.Link href="#artwork">Artwork</Nav.Link>
            <Nav.Link href="#commissions">Commissions</Nav.Link>
            <Nav.Link href="#contact">Contact</Nav.Link>
          </Nav>
        </Container>
      </Navbar>

      <section className="bg-light text-dark p-5 text-start" style={{marginTop: '50px', paddingTop: '30px'}} id='home'>
        <div>
          <Container>
            <div className="d-sm-flex align-items-center justify-content-between">
              <Fade left>
                <div>
                  <h1>Hello, I am <span className="text-primary">Beanep</span></h1>
                  <p className="lead my-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                </div>
              </Fade>
              <Flash>
                <img className="img-fluid w-50 pb-5 px-5 rounded-pill d-none d-sm-block" src={Bea} alt="beanep"></img>
              </Flash>
            </div>
          </Container>
        </div>
      </section>
      <div id="artwork"></div>
      <section class="bg-primary text-light pb-5 text-center" style={{ paddingBottom: '100px' }}>
        <img src={Wave} class="bottom-image" alt="wave"></img>
          <h1 style={{marginTop: '185px'}}>Interested in seeing some of my <span className="text-warning">artwork</span>?</h1>
          <h2 style={{paddingBottom: '50px'}}>Take a look, then!</h2>
        <Carousel className="bg-dark p-5" style={{width: '90%', margin: 'auto', borderRadius: '45px'}} variant="light">
          <Carousel.Item interval={3000}>
            <img
              className="d-block w-25"
              src={Wolfez}
              alt="First slide"
              style={{margin: 'auto'}}
            />
            <Carousel.Caption>
              <h5 className="d-none d-sm-block">Commission by Wolfez</h5>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item interval={3000}>
            <img
              className="d-block w-25"
              src={McDonalds}
              alt="Second slide"
              style={{margin: 'auto'}}
            />
            <Carousel.Caption>
            <h5 className="d-none d-sm-block">Commission by Bqre</h5>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item interval={3000}>
            <img
              className="d-block w-25"
              src={infer}
              alt="Third slide"
              style={{margin: 'auto'}}
            />
            <Carousel.Caption>
            <h5 className="d-none d-sm-block">Commission by Infernalfae</h5>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </section>

      <section className="bg-light text-dark pb-5 text-center">
        <Flash>
          <h2 style={{paddingTop: '120px'}} id="commissions">Liking what you see?</h2>
          <h1 style={{paddingBottom: '50px'}}>How about getting your own?!</h1>
        </Flash>
        <Container>
          <div className="d-sm-flex align-items-center justify-content-between p-5">
            <Fade left>
              <Card className="m-auto" style={{ width: '18rem', height: '15rem' }}>
                <Card.Body>
                  <Card.Title className="text-success">Will do</Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">Requests I <strong>might</strong> take!</Card.Subtitle>
                  <Card.Text>
                    - Humans/Humanoids<br />
                    - MC Skins<br />
                    - Fanart<br />
                    - Slight Gore<br />
                    - OCs<br />
                    - Simple Backgrounds<br />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Fade>
            <Flash>
              <Card className="m-auto" style={{ width: '18rem', height: '20rem' }}>
                <Card.Body>
                  <Card.Title>How it Works</Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">Please read <strong>before</strong> messaging!</Card.Subtitle>
                  <Card.Text>
                    - Discuss details<br />
                    - Payment sent <strong>after</strong> sketch<br />
                    - Final project will be sent after <strong>2 weeks!</strong><br />
                    - If taken <strong>3 weeks</strong> or longer to deliver, a refund will be issued.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Flash>
            <Fade right>
              <Card className="m-auto" style={{ width: '18rem', height: '15rem' }}>
                <Card.Body>
                  <Card.Title className="text-danger">Will not do</Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">I will not accept the following requests</Card.Subtitle>
                  <Card.Text>
                    - NSFW<br />
                    - Heavy Gore<br />
                    - Detailed Animals<br />
                    - Detailed Backgrounds<br />
                    - Realism<br />
                    - Offensive Material
                  </Card.Text>
                </Card.Body>
              </Card>
            </Fade>
          </div>
          <div className="d-sm-flex align-items-center justify-content-between p-5">
            <Fade left>
              <Card className="m-auto" style={{ width: '18rem' }}>
                <Card.Body>
                  <Card.Title>Neck Up</Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">Pricing for Neck-Up Drawings</Card.Subtitle>
                  <Card.Text>
                    <strong>Line-art</strong>: <span className="text-success">$5.00</span><br />
                    <strong>Base Colors</strong>: <span className="text-success">$7.00</span><br />
                    <strong>Full Render</strong>: <span className="text-success">$10.00</span><br />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Fade>
            <Flash>
              <Card className="m-auto" style={{ width: '18rem' }}>
                <Card.Body>
                  <Card.Title>Bust</Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">Pricing for Bust-Up Drawings</Card.Subtitle>
                  <Card.Text>
                    <strong>Line-art</strong>: <span className="text-success">$10.00</span><br />
                    <strong>Base Colors</strong>: <span className="text-success">$12.00</span><br />
                    <strong>Full Render</strong>: <span className="text-success">$15.00</span><br />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Flash>
            <Fade right>
              <Card className="m-auto" style={{ width: '18rem' }}>
                <Card.Body>
                  <Card.Title>Full Body</Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">Pricing for Full-Body Drawings</Card.Subtitle>
                  <Card.Text>
                    <strong>Line-art</strong>: <span className="text-success">$15.00</span><br />
                    <strong>Base Colors</strong>: <span className="text-success">$17.00</span><br />
                    <strong>Full Render</strong>: <span className="text-success">$20.00</span><br />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Fade>
          </div>
          <Card className="m-auto" style={{ width: '18rem' }}>
            <Card.Body>
              <Card.Title>Emotes</Card.Title>
                <Card.Subtitle className="mb-2 text-muted">Pricing for Emotes</Card.Subtitle>
                <Card.Text>
                  <strong>Per Emote</strong>: <span className="text-success">$4.00</span><br />
                  <strong>3 Emote Bundle</strong>: <span className="text-success">$10.00</span><br />
                </Card.Text>
            </Card.Body>
          </Card>
        </Container>
      </section>
      <section className="bg-primary text-light pb-5 text-center">
        <h2 class="p-5" id="contact">Feeling a bit chatty?</h2>
        <h1>Send me a message!</h1>
        <Container>
          <div className="d-sm-flex align-items-center justify-content-around p-5">
            <h3 className="text-warning"><i class="bi bi-discord"></i> bea#9240</h3>
            <h3 className="text-warning"><i class="bi bi-twitter"></i> _beanep</h3>
          </div>
        </Container>
      </section>
    </>
  );
}

export default App;
